import PropTypes from "prop-types";
import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./style.css"

const Layout = (props) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [showSidebarMenu, setShowSidebarMenu] = useState(true);

  return (
    <React.Fragment>
      <div style={{ position: "relative" }} id="layout-wrapper sidebar-enable">
        <header id={showSidebarMenu ? "page-topbar" : "page-topbar-expanded"}>
          <Header
            theme={"dark"}
            isMenuOpened={isMenuOpened}
            openLeftMenuCallBack={() => { setIsMenuOpened(!isMenuOpened); }}
            ShowSidebarMenu={showSidebarMenu}
            ToggleSidebarMenu={() => { setShowSidebarMenu(!showSidebarMenu); }}
          />
        </header>
        <div className={showSidebarMenu ? " main-layout page-content" : " main-layout-collapsed "}>{props.children}</div>
        <Sidebar
          ShowSidebarMenu={showSidebarMenu}
          ToggleSidebarMenu={() => { setShowSidebarMenu(!showSidebarMenu); }}
        />
      </div>

    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  isPreloader: PropTypes.bool,
  layoutWidth: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default Layout;
